export const PLAY_SCREEN_SCROLL_STATE = "PLAY_SCREEN_SCROLL_STATE";
export const HOME_SCREEN_SCROLL_STATE = "HOME_SCREEN_SCROLL_STATE";
export const VIDEO_PLAYER_SEEK_STATE = "VIDEO_PLAYER_SEEK_STATE";
export const MUSIC_PLAYER_SEEK_STATE = "MUSIC_PLAYER_SEEK_STATE";
export const HOME_SCREEN_MENU_STATE = "HOME_SCREEN_MENU_STATE";
export const MEDIA_SELECTION_STATE = "MEDIA_SELECTION_STATE";
export const SUBSCRIPTION_STATUS_POSITION_STATE = "SUBSCRIPTION_STATUS_POSITION_STATE";
export const INSTALLED_PWA = "INSTALLED_PWA";
export const INTERACTION_POSITION_STATE = "INTERACTION_POSITION_STATE";
export const INTERACTION_CLOSED_STATE = "INTERACTION_CLOSED_STATE";